export default "__VITE_ASSET__Coe$gwYv__"